require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./partir-en-semestre-dchange-3-e-anne-ba-2-5-0-0.json") })
        }
      }, "path---partir-en-semestre-dchange-3-e-anne-ba-2-5-0-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---partir-en-semestre-dchange-3-e-anne-ba-2-5-0-0!./.cache/json/partir-en-semestre-dchange-3-e-anne-ba-2-5-0-0.json
// module id = 515
// module chunks = 231608221292675